import React from 'react';
import { Link } from 'react-router-dom';
import './Intervention.css';

// Import icons for each intervention (replace with actual imports or assets)
import rugIcon from '../assets/rug-icon.png';
import bambooIcon from '../assets/bamboo-icon.png';
import basketryIcon from '../assets/basketry-icon.png';
import stitchingIcon from '../assets/stitching-icon.png';

const interventions = [
  { name: 'Rugs', path: '/intervention/rugs', icon: rugIcon },
  { name: 'Bamboo', path: '/intervention/bamboo', icon: bambooIcon },
  { name: 'Basketry', path: '/intervention/basketry', icon: basketryIcon },
  { name: 'Stitching', path: '/intervention/stitching', icon: stitchingIcon },
];

const Intervention = () => {
  return (
    <div className="intervention-page">
      <h1><Link to="/intervention">Explore Our Interventions</Link></h1>
      
      <ul className="intervention-list">
        {interventions.map((item) => (
          <li key={item.name} className="intervention-item">
            <Link to={item.path} className="intervention-link">
              <img src={item.icon} alt={`${item.name} Icon`} className="intervention-icon" />
              <span className="intervention-text">{item.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Intervention;
